'use client';
import React, { useEffect } from 'react';
import Typography from '@ui/Typography';
import { cx } from 'cva';
import { LucideLoader } from 'lucide-react';
import CommunityReview from './CommunityReview';
import CommunityReviewForm from './CommunityReviewForm';
import { usefetchCommunityReviews, usefetchPublicCommunityReviews } from '@/actions/community-review.actions.js';
import useHasUserSession from '@/hooks/useHasUserSession';

function CommunityReviews(props) {
  const {
    nonProfit,
    nonProfitId,
    disabled = false,
    className = '',
    communityRating,
    handleRedirect,
  } = props;

  const hasUserSession = useHasUserSession();

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch: refetchComments,
  } = hasUserSession
    ? usefetchCommunityReviews(nonProfitId)
    : usefetchPublicCommunityReviews(nonProfitId);

  const handleLoadMoreReviews = async () => {
    if (hasNextPage && !isFetchingNextPage) {
      await fetchNextPage();
    }
  };

  useEffect(() => {
    refetchComments();
  }, [communityRating]);

  return (
    <div
      className={cx(
        'flex w-full flex-col items-stretch justify-start gap-2',
        className,
      )}>
      {/* {!disabled && (
        <div className="mb-2">
          <CommunityReviewForm nonProfitId={nonProfitId} />
        </div>
      )} */}
      <div className="flex flex-col gap-2">
        {data?.pages?.map((group, i) => (
          <React.Fragment key={i}>
            {group.reviews.map((review) => (
              <CommunityReview
                nonProfit={nonProfit}
                key={review.id}
                nonProfitId={nonProfitId}
                review={review}
                handleRedirect={handleRedirect}
              />
            ))}
          </React.Fragment>
        ))}
      </div>

      {hasNextPage && (
        <Typography
          variant="caption"
          component="button"
          className="hover:text-text-hyperlink hover:underline"
          onClick={handleLoadMoreReviews}>
          Load more reviews
        </Typography>
      )}

      {isFetchingNextPage && (
        <LucideLoader className="h-6 w-6 animate-spin text-center text-primary" />
      )}
    </div>
  );
}

export default CommunityReviews;
